import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {BsDatepickerModule} from 'ngx-bootstrap';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {SharedModule} from '../../_shared/shared.module';
import { BrandService } from './brands.service';
import { CommonModule } from '@angular/common';
import { Daterangepicker } from 'ng2-daterangepicker';
import { BrandsComponent } from './brands.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
const routes: Routes = [
  {
    path: '',
    component: BrandsComponent,
    data: {
      title: 'Quản lý thương hiệu'
    },
  }
];
@NgModule({
  imports: [
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  declarations: [BrandsComponent],
  providers: [BrandService]
})
export class BrandsModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/brand-manage/brands.module.ts